import { ASSESSMENT, LESSON } from 'global/constants';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import {
  GET_STIMULUS_ASSESSMENT,
  GET_STIMULUS_LESSON,
} from './create-stimulus.graphql';
import type {
  GetStimulusLessonQuery,
  GetStimulusLessonQueryVariables,
} from './create-stimulus.graphql.generated';
import type {
  GetStimulusAssessmentQuery,
  GetStimulusAssessmentQueryVariables,
} from './create-stimulus.graphql.generated';

export const useGetContentData = (id: number, lessonTypeParam: string) => {
  const isLessonStimulus = lessonTypeParam === LESSON;
  const isAssessmentStimulus = lessonTypeParam === ASSESSMENT;

  const {
    data: lessonData,
    error: lessonError,
    loading: lessonLoading,
  } = useLoggingQuery<GetStimulusLessonQuery, GetStimulusLessonQueryVariables>(
    GET_STIMULUS_LESSON,
    {
      variables: {
        input: {
          id,
        },
      },
      skip: !id || !isLessonStimulus,
      // Do not cache to prevent requerying in other places where we use the same
      // underlying query getLessonById
      fetchPolicy: 'no-cache',
    }
  );

  const {
    data: assessmentData,
    error: assessmentError,
    loading: assessmentLoading,
  } = useLoggingQuery<
    GetStimulusAssessmentQuery,
    GetStimulusAssessmentQueryVariables
  >(GET_STIMULUS_ASSESSMENT, {
    variables: {
      input: {
        id,
      },
    },
    skip: !id || !isAssessmentStimulus,
    // Do not cache to prevent requerying in other places where we use the same
    // underlying query getLessonById
    fetchPolicy: 'no-cache',
  });

  return {
    returnUrl:
      lessonData?.getLessonById?.slug ||
      assessmentData?.getAssessmentById?.slug,
    subjects:
      lessonData?.getLessonById?.subjects ||
      assessmentData?.getAssessmentById?.subjects,
    years:
      lessonData?.getLessonById?.years ||
      assessmentData?.getAssessmentById?.years,
    loading: lessonLoading || assessmentLoading,
    error: lessonError || assessmentError,
  };
};
